import { render, staticRenderFns } from "./ButtonCheckbox.vue?vue&type=template&id=51b51601&"
import script from "./ButtonCheckbox.vue?vue&type=script&lang=js&"
export * from "./ButtonCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports